import styled from '@emotion/styled';
import React from 'react';
import { ssColorDarkNavy, ssColorMidBlueGrey } from '../constants/style-constants';
import { hunit, vunit } from '../lib/style-helpers';
import summaryContentType from '../proptypes/summary-content';
import { BigNumber, DataDescription } from './Typography';

const Wrapper = styled.div`
  display: flex;
`;

const Unit = styled.div`
  width: 50%;
  padding-top: ${hunit(2)};

  &:first-of-type {
    border-right: 3px solid ${ssColorDarkNavy};
    margin-right: ${vunit(2)};
  }
`;

const Link = styled.a`
  color: ${ssColorMidBlueGrey};
  text-transform: uppercase;
  font-size: 0.8rem;
`;

const Summary = ({ content }) => {
  const extractPunctuation = (text) => {
    const punctuationRegex = /[$%]/g;
    const result = text
      .toString()
      .split('')
      .map(subStr => (punctuationRegex.test(subStr) ? <span key={subStr}>{subStr}</span> : subStr));
    return result;
  };

  return (
    <Wrapper>
      {content.map(({
        key,
        value,
        units,
        descriptor,
        link,
      }) => (
        <Unit key={key}>
          {value && (<BigNumber>{extractPunctuation(value)}</BigNumber>)}
          {units && (<DataDescription light flush={units && descriptor}>{units}</DataDescription>)}
          {descriptor
            && (<DataDescription small={units && descriptor}>{descriptor}</DataDescription>)}
          {link && (<Link {...link} />)}
        </Unit>
      ))}
    </Wrapper>
  );
};

Summary.propTypes = {
  content: summaryContentType.isRequired,
};

export default Summary;
